export const PERSONAS = {
  collector: "collector",
  advanced: "advanced",
} as const

export const getRewrittenHomePage = () => {
  return "/discover"
}

export type Persona = keyof typeof PERSONAS

export const PERSONA_COOKIE_NAME = "persona"

export function parsePersona(persona: string | undefined): Persona {
  if (persona && persona in PERSONAS) {
    return persona as Persona
  }
  return PERSONAS.collector
}

export function getPersonaStaticParams() {
  return Object.values(PERSONAS).map(persona => ({ persona }))
}

// biome-ignore lint/complexity/noBannedTypes: this is fine as its just a default
export type PersonaParams<T extends Record<string, string> = {}> = T & {
  persona: Persona
}
